import * as React from "react";
import { style } from "typestyle";

interface IProps {
  size: number;
  color?: string;
  rotation?: number;
}

export const TicketWhiteIcon = (props: IProps) => {
  const className = style({
    width: props.size,
    height: props.size,
    stroke: props.color,
    transform: `rotate(${props.rotation}deg)`
  });
  return (
    <React.Fragment>
      <svg
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 95.1 100.3"
        className={className}
      >
        <rect x="11.6" y="47.2" width="69.8" height="4.4" />
        <path
          d="M10.5,6.5C10.5,2.9,13.4,0,17,0h20.7l8.7,13.1L55.2,0h22.9c3.6,0,6.5,2.9,6.5,6.5v87.2c0,3.6-2.9,6.5-6.5,6.5
	H17c-3.6,0-6.5-2.9-6.5-6.5V6.5z M11.6,47.2v4.4h3.3v42.2c0,1.2,1,2.2,2.2,2.2h61.1c1.2,0,2.2-1,2.2-2.2V51.6h1.1v-4.4h-1.1V6.5
	c0-1.2-1-2.2-2.2-2.2H57.4L46.5,19.6L35.6,4.4H17c-1.2,0-2.2,1-2.2,2.2v40.7H11.6z"
        />
      </svg>
    </React.Fragment>
  );
};
